// extracted by mini-css-extract-plugin
export var stepActive = "_1p-3";
export var stepCompleted = "_1p-4";
export var stepConnectorLine = "_1p-b";
export var stepIndicatorCircle = "_1p-6";
export var stepIndicatorCircleCompleted = "_1p-7";
export var stepIndicatorCircleDefault = "_1p-8";
export var stepIndicatorTextCompleted = "_1p-9";
export var stepIndicatorTextDefault = "_1p-a";
export var stepPending = "_1p-5";
export var wizardContainer = "_1p-1";
export var wizardContent = "_1p-2";
export var wizardModal = "_1p-0";